export default {
    LeftMenu: {
        Control: "Control",
        EmployeeList: "Nhân viên",
        CollapseText: "Thu gọn",
        Dashboard: "Dashboard",
        ScanWebsites: "Quét webside",
        ScanDevice: "Quét thiết bị",
        VulnerabilityTesting: "Kiểm thử lỗ hổng",
        EngineManagement: "Quản lý Engine",
        AIPlatform: "Nền tảng AI",
        Report: "Báo cáo",
        User: "Quản lý người dùng",
        History: "Lịch sử truy cập",
        Setting: "Thiết lập",
        Anonymous: "Hệ thống ẩn danh",
        Datalake: "Data lake",
        About: "Giới thiệu về công ty",
        FA: "2FA",
        Role: "Vai trò",
        Watchlist: "Đối tượng theo dõi",
        Setting: "Thiết lập",
        Config: "Cấu hình",
        System: "Hệ thống",
        Evidences: "Dẫn chứng"
    }
}